<template>
    <div id="configuration" class="configuration">
        <b-navbar id="conf-nav" toggleable="lg" type="dark" variant="dark">
            <b-navbar-brand :to="{ name: 'Home'}">
                <b-img class="inova-logo align-middle" :src="`${publicPath}assets/images/inpart-logo-white.png`"></b-img>
                <span class="align-middle ml-3">Opportunity Portal</span>
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item :to="{ name: 'Clients'}" :active="$route.name.match('clients')">
                        <b-icon icon="people"></b-icon>
                        Client Instances
                    </b-nav-item>
                    <b-nav-item :to="{ name: 'ConfPortals'}" :active="$route.name.match('portals')">
                        <b-icon icon="clipboard"></b-icon>
                        Portals
                    </b-nav-item>
                    <b-nav-item :to="{ name: 'ConfMyPortals'}" :active="$route.name.match('my-portals')">
                        <b-iconstack>
                            <b-icon stacked icon="person-fill" scale="0.70" shift-v="-2"></b-icon>
                            <b-icon stacked icon="clipboard"></b-icon>
                        </b-iconstack>
                        My Portals
                    </b-nav-item>
                    <b-nav-item :to="{ name: 'ConfFiles'}" :active="$route.name.match('files')">
                        <b-icon icon="folder2"></b-icon>
                        Files
                    </b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav class="ml-auto">
                    <b-nav-item :to="{ name: 'Monitoring'}" :active="$route.name.match('monitoring')">
                        <b-icon icon="display"></b-icon>
                        Monitoring
                    </b-nav-item>
                    <b-nav-item-dropdown right>
                        <template v-slot:button-content>
                            <em>
                                <b-icon icon="person-circle"></b-icon>
                                {{ currentUser.username }}</em>
                        </template>
                        <b-dropdown-header>
                            <b-icon icon="info-circle-fill"></b-icon>
                            Version {{ version }}
                        </b-dropdown-header>
                        <b-dropdown-header>
                            <b-icon icon="envelope"></b-icon>
                            {{ currentUser.email }}
                        </b-dropdown-header>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item href @click.prevent="logOut">
                            <b-icon icon="box-arrow-right"></b-icon>
                            Sign Out
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
        <b-alert id="info-message" :show="dismissCountDown" :variant="messageType" fade dismissible
                 @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
            <p>{{ message }}</p>
            <b-progress :variant="messageType" :max="dismissSecs" :value="dismissCountDown" height="4px"
                        animated></b-progress>
        </b-alert>

        <router-view :key="$route.path"/>

        <b-modal id="loading-modal" size="sm" hide-header hide-footer centered>
            <div class="text-center">
                <b-spinner label="Spinning"></b-spinner>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: "Configuration",
        created() {
            document.title = "Configuration";
        },
        data() {
            return {
                dismissSecs: 5,
                dismissCountDown: 0,
                showMessage: false,
                messageType: null,
                message: '',
                publicPath: process.env.BASE_URL,
                version: this.$appSettings.version,
            };
        },
        computed: {
            currentUser() {
                return this.$store.state.auth.user;
            }
        },
        mounted() {
            if (!this.currentUser) {
                this.$router.push('/login');
            }
            window.addEventListener('scroll', this.scrollListener);
        },
        methods: {
            scrollTop() {
                this.intervalId = setInterval(() => {
                    if (window.pageYOffset === 0) {
                        clearInterval(this.intervalId)
                    }
                    window.scroll(0, window.pageYOffset - 50)
                }, 20)
            },
            scrollListener() {
                this.visible = window.scrollY > 150
            },
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            displayMessage(messageType, message) {
                this.$bvModal.hide('loading-modal');
                this.dismissCountDown = this.dismissSecs
                this.messageType = messageType;
                this.message = message;
                this.scrollTop();
            },
            displaySuccessMessage(message) {
                this.displayMessage('success', message);
            },
            displayErrorMessage(message) {
                this.displayMessage('danger', message);
            },
            logOut() {
                this.$store.dispatch('auth/logout');
                this.$router.push('/login');
            }
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.scrollListener);
        }
    }
</script>

<style>
    th.required div::after,
    .required label::after {
        content: " *";
        color: red;
    }

    .inova-logo {
        max-height: 25px;
    }
</style>